<template>
  <div>
    <div class="login">
      <div class="login-form">
        <div class="login-header">
          <img src="../../assets/images/logo.svg" width="100" height="100" alt>
          <p>{{ $Config.siteName }}</p>
        </div>
        <el-input
          placeholder="请输入用户名"
          suffix-icon="fa fa-user"
          v-model="username"
          style="margin-bottom: 18px"
        ></el-input>

        <el-input
          placeholder="请输入密码"
          suffix-icon="fa fa-keyboard-o"
          v-model="password"
          type="password"
          style="margin-bottom: 18px"
          @keyup.native.enter="login"
        ></el-input>

        <el-button
          type="primary"
          :loading="loginLoading"
          style="width: 100%;margin-bottom: 18px"
          @click.native="login"
        >登录</el-button>
        <div>
          <el-checkbox v-model="Remenber">Remenber</el-checkbox>
          <a href="javascript:;" style="float: right;color: #3C8DBC;font-size: 14px">Register</a>
        </div>
      </div>
    </div>
    <Footer class="footer"></Footer>
  </div>
</template>

<script>
import Footer from '../layout/Footer.vue';
export default {
  data() {
    return {
      username: "",
      password: "",
      Remenber: true,
      loginLoading: false
    };
  },
  components: {
    Footer
  },
  methods: {
    login() {
      let APP = this;
      APP.loginLoading = true;
      APP.$axios
        .post(this.baseUrl + "/myLogin", {
        // .post("/gymTest/myLogin", {
          username: APP.username,
          password: APP.password
        })
        .then(res => {
          console.log(res);
          if (res.data.code == 0) {
            sessionStorage.setItem(APP.$Config.tokenKey, "123456789");
            APP.$notify({
              title: "登录成功",
              message: "欢迎使用Gymme Performance后台管理系统。",
              type: "success"
            });
            APP.$router.push({ path: "/" });
          } else {
            APP.$notify.error({
              title: "登录失败",
              message: "请输入正确的用户名和密码",
            });
          }
            APP.loginLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="less" scoped>
@import "Login.less";
.footer {
  position: absolute;
  bottom: 1px;
}
</style>
